import {
    AfterViewInit,
    ChangeDetectionStrategy,
    Component,
    ElementRef,
    EventEmitter,
    Input, OnDestroy,
    OnInit,
    Output,
    ViewChild,
} from '@angular/core';
import {interval, Observable} from 'rxjs';
import {tap} from 'rxjs/operators';

@Component({
    selector: 'tart-two-factor-authentication',
    templateUrl: './two-factor-authentication.component.html',
    styleUrls: ['./two-factor-authentication.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TwoFactorAuthenticationComponent implements OnInit, AfterViewInit, OnDestroy {
    @ViewChild('element') containerInputs: ElementRef;
    @ViewChild('firstInput') firstInputNumber: ElementRef;
    @ViewChild('secondInput') secondInputNumber: ElementRef;
    @ViewChild('thirdInput') thirdInputNumber: ElementRef;
    @ViewChild('forthInput') forthInputNumber: ElementRef;
    @ViewChild('fifthInput') fifthInputNumber: ElementRef;
    @ViewChild('sixthInput') sixthInputNumber: ElementRef;

    @Input() phoneNumber: string;
    @Output() verifyOTPEmitter = new EventEmitter<string>();
    @Output() resendOTPEmitter = new EventEmitter();
    @Output() timerInSecondChange = new EventEmitter();

    time$: Observable<number>;
    countDown = 180;
    showTime = '';
    resend = false;
    firstNumber: number;
    secondNumber: number;
    thirdNumber: number;
    forthNumber: number;
    fifthNumber: number;
    sixthNumber: number;
    otp = '';

    _timerInSecond = 180;
    _confirmationOTP = true;

    get confirmationOTP(): boolean {
        return this._confirmationOTP;
    }

    @Input() set timerInSecond(timerInSecond: number) {
        this._timerInSecond = timerInSecond;
        this.countDown = timerInSecond;
        this.setShowTime(this.countDown);
    };

    @Input() set confirmationOTP(confirmationOTP: boolean) {
        if(confirmationOTP) {
            this._confirmationOTP = confirmationOTP;
        } else {
            this._confirmationOTP = this.otp.length === 0;
        }
    };

    ngOnInit(): void {
        this.setShowTime(this.countDown);
        this.time$ = interval(1000).pipe(tap(() => this.countDownTimer()));
    }

    ngAfterViewInit(): void {
        this.focusInput(this.firstInputNumber.nativeElement);
    }

    resendOTP(): void {
        this.resend = false;
        this.resetInputs();
        this.resendOTPEmitter.emit();
    }

    setShowTime(countDown: number): void {
        const minute = Math.floor(countDown / 60);
        const second = countDown % 60;
        this.showTime = `${minute}:${second.toString().padStart(2, '0')}`;
    }

    countDownTimer(): void {
        if (!this.resend) {
            if (this.countDown > 0) {
                this.countDown--;
            } else {
                this.resend = true;
                this.countDown = this._timerInSecond;
            }
            this.setShowTime(this.countDown);
        }
    }

    checkInput($event, inputName: string): void {
        this.otp = '' + this.firstNumber + this.secondNumber + this.thirdNumber + this.forthNumber +
            this.fifthNumber + this.sixthNumber;
        switch (inputName) {
            case 'secondInput':
                if($event.inputType === 'insertText') {
                    this.focusInput(this.secondInputNumber.nativeElement);
                }
                break;
            case 'thirdInput':
                this.focusInput($event.inputType === 'deleteContentBackward' ?
                    this.firstInputNumber.nativeElement : this.thirdInputNumber.nativeElement);
                break;
            case 'forthInput':
                this.focusInput($event.inputType === 'deleteContentBackward' ?
                    this.secondInputNumber.nativeElement : this.forthInputNumber.nativeElement);
                break;
            case 'fifthInput':
                this.focusInput($event.inputType === 'deleteContentBackward' ?
                    this.thirdInputNumber.nativeElement : this.fifthInputNumber.nativeElement);
                break;
            case 'sixthInput':
                this.focusInput($event.inputType === 'deleteContentBackward' ?
                    this.forthInputNumber.nativeElement : this.sixthInputNumber.nativeElement);
                break;
            default:
                if($event.data == null) {
                    this.focusInput(this.fifthInputNumber.nativeElement);
                }
        }
        if(this.otp.length === 6) {
            this.verifyOTPEmitter.emit(this.otp);
        }
    }

    focusInput(nativeElement: any): void {
        nativeElement.focus();
    }

    resetInputs(): void {
        this.firstNumber = null;
        this.secondNumber = null;
        this.thirdNumber = null;
        this.forthNumber = null;
        this.fifthNumber = null;
        this.sixthNumber = null;
        this.otp = '';
        this.focusInput(this.firstInputNumber.nativeElement);
    }

    ngOnDestroy(): void {
        // this.timerInSecondChange.emit(this.countDown);
    }
}
